import { render, staticRenderFns } from "./UserCitiesMultiselectNew.vue?vue&type=template&id=678a0488"
import script from "./UserCitiesMultiselectNew.vue?vue&type=script&lang=ts"
export * from "./UserCitiesMultiselectNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('678a0488')) {
      api.createRecord('678a0488', component.options)
    } else {
      api.reload('678a0488', component.options)
    }
    module.hot.accept("./UserCitiesMultiselectNew.vue?vue&type=template&id=678a0488", function () {
      api.rerender('678a0488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/UserCitiesMultiselectNew.vue"
export default component.exports